
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29.938 19.958"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.757 9.22A16.67 16.67 0 0014.969 0 16.673 16.673 0 00.181 9.221a1.681 1.681 0 000 1.517 16.67 16.67 0 0014.788 9.22 16.673 16.673 0 0014.788-9.221 1.681 1.681 0 000-1.517zm-14.788 8.244a7.484 7.484 0 117.484-7.484 7.484 7.484 0 01-7.484 7.484zm0-12.474a4.954 4.954 0 00-1.315.2 2.487 2.487 0 01-3.477 3.477 4.978 4.978 0 104.792-3.677z","fill":"#243882"}})])
          )
        }
      }
    